import LeadEvent, {LeadEventTypeEnum} from "./LeadEvent";
import {LeadAppointmentEventDataApiDto, LeadEventApiDto} from "../../../api/model/rest";
import AuthenticatedEntity from "../../user/AuthenticatedEntity";
import AppointmentStatus from "../../appointment/AppointmentStatus";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import {IconColor} from "../../../hiberUiKit/src/molecules/StreamItem/StreamItemIcon";
import DateUtils from "../../../utils/DateUtils";
import moment = require("moment");

/**
 * Lead appointment event.
 */
export default class LeadAppointmentEvent extends LeadEvent {
	constructor(public readonly id: string,
		public readonly leadId: string,
		public readonly type: LeadEventTypeEnum,
		public readonly entity: AuthenticatedEntity,
		public readonly creationDate: moment.Moment,
		public readonly referenceNumber: string,
		public readonly data: LeadAppointmentEventData) {
		super(id, leadId, type, entity, creationDate, referenceNumber);
	}

	public static fromJson(json: LeadEventApiDto): LeadEvent {
		const type = json.type == LeadEventTypeEnum.AppointmentCreated ? LeadEventTypeEnum.AppointmentCreated :
			LeadEventTypeEnum.AppointmentUpdated;
		const entity = AuthenticatedEntity.fromJson(json.entity);
		const data = LeadAppointmentEventData.fromJson(json.data as LeadAppointmentEventDataApiDto);
		return new LeadAppointmentEvent(json.id, json.leadId.toString(), type, entity, moment(json.createdAt),
			json.referenceNumber, data);
	}

	getIcon() {
		return Icon.Appointments;
	}

	getIconColor(): IconColor {
		return IconColor.Burgundy;
	}

	getActivityType(): string {
		return `APPOINTMENT`
	}

	getActivityMessage(): string {
		return `Scheduled for ${this.data.appointmentDate.format(DateUtils.DATE_TIME_FORMAT)}`;
	}

	getDisplayText() {
		return this.type == LeadEventTypeEnum.AppointmentCreated ? "New appointment added" : "Appointment has been changed"
	}

	statusDisplayText() {
		return this.data.status.label.toLocaleLowerCase();
	}

	newStatusDisplayText() {
		return this.data.status.label.toLocaleLowerCase();
	}
}

export class LeadAppointmentEventData {
	constructor(public readonly appointmentId: string,
		public readonly appointmentDate: moment.Moment,
		public readonly status: AppointmentStatus) {}

	public static fromJson(json: LeadAppointmentEventDataApiDto): LeadAppointmentEventData {
		return new LeadAppointmentEventData(json.id, moment(json.appointmentDate), AppointmentStatus.fromString(json.status));
	}
}